var _jsxFileName = "/codebuild/output/src3324576443/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/auth/ResetPassword/states/ResetSuccess.tsx";
import React from 'react';
import { Text } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
const ResetSuccess = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.media.passwordResetSuccess'),
    alt: "horizontal logo of free style libre",
    id: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.media.passwordResetSuccess",
    style: {
      marginTop: '40px',
      height: '105px',
      objectFit: 'contain'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.primaryText",
    testID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.primaryText",
    fontWeight: '$h2.medium',
    fontSize: "$h2.medium",
    color: "$text.100",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 7
    }
  }, i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.primaryText')), /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.secondaryText",
    testID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.secondaryText",
    color: "$text.100",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }, i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.secondaryText')), /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.bodyText",
    testID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.bodyText",
    color: "$text.100",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 7
    }
  }, i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.bodyText')));
};
export { ResetSuccess };